import styled from 'styled-components';
import { device } from './responsives';

// ===== Graph components ========
export const LoadCardContainer = styled.div`
  @media ${device.minLaptop}{
  display: grid;
  margin-top: 40px;
  margin-left: 30%;
  margin-right: 30%;
  }
  @media ${device.mobileL}{
    margin: 0px;
    padding: 0px;
  }
`

export const TextBanner = styled.div`
  height: auto;
  font-family: 'Roboto';
  font-weight: 900;
  font-size: 20px;
  text-align: center;
  color: #4a4a4a;
  padding-top: 10%;
  @media ${device.mobileL}{
    padding-top: 10%;
  }
`

export const GraphImg = styled.img`
  width: 400px;
  height: 400px;
  aspect-fit: cover;
  display: inline-block;
  padding: 0px;
`

// ======= Review Components ======

export const BlankRevContainer = styled.div`
  display: block;
  height: 60%;
  position: relative;
`

export const RevExampleImg = styled.img`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  aspect-fit: cover;
  width: 50%;
  height: auto;
`

export const RevTextBanner = styled(TextBanner)`

`

// ======== Summary components ====

export const BlankSumContainer = styled.div`
  display: inline-block;
`

export const SumExampleImg = styled.img`
  display: inline-block;
  aspect-fit: cover;
  width: 150px;
  height: auto;
  margin-left: 20px;
`

export const SumTextBanner = styled.div`
  font-family: 'Roboto';
  font-weight: 900;
  font-size: 20px;
  margin-left: 20px;
  color: #4a4a4a;
  display: inline-block;
  width: 80%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);

`
